import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Container } from '../../ui/Container';
import { Button } from '../../ui/Button';
import { GeometricAccent } from '../../ui/GeometricAccent';
export function HomeHero() {
  return <section className="relative overflow-hidden" data-id="element-640" data-mp="2lriyfn6vru">
      <GeometricAccent variant="dots" className="absolute right-8 top-16 w-32 h-32" opacity={0.4} data-id="element-641" data-mp="3dan9s1z118" />

      <Container className="relative pt-8 md:pt-10 lg:pt-12 pb-16 md:pb-24 lg:pb-28" data-id="element-642" data-mp="nqlhvx91kk5w">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-643" data-mp="rrx8o63njbfo">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} className="lg:col-span-6 flex flex-col gap-7" data-id="element-644" data-mp="dtqilc4y2fqk">
            <span className="inline-flex items-center gap-2 self-start px-3 py-1.5 rounded-full bg-sage-100 text-forest-700 text-[11px] font-semibold tracking-[0.14em] uppercase" data-id="element-645" data-mp="28dyqgz6ac9fz">
              International Islamic Learning Hub
            </span>

            <h1 className="font-display text-[2.25rem] sm:text-5xl lg:text-[3.75rem] leading-[1.05] tracking-tightest text-ink-900" data-id="element-646" data-mp="2iatn1cizzzrm">
              Empowering Muslim
              <br data-id="element-647" data-mp="2rc9wni1znxus" />
              <span className="text-forest-700" data-id="element-648" data-mp="2rbrte1gwsjdd">Children And Families</span>
              <br data-id="element-649" data-mp="2nb7vuwsfbdqp" />
              <span className="font-normal text-ink-700 text-[1.8rem] sm:text-4xl lg:text-[2.6rem]" data-id="element-650" data-mp="2nbr23g8podow">
                in Non-Muslim Countries
              </span>
            </h1>

            <p className="text-ink-700 text-base md:text-lg leading-relaxed max-w-xl" data-id="element-651" data-mp="2w5m8erlkka64">
              We help Muslim children grow with confidence, identity, and
              dignity while integrating successfully into non-Muslim societies.
            </p>

            <p className="text-forest-700 font-medium text-[15px]" data-id="element-652" data-mp="3d5yudo2j49vl">
              Children first. Education with protection. Integration without
              loss of identity.
            </p>

            <div className="flex flex-wrap gap-3 pt-2" data-id="element-653" data-mp="3n3v5ifvgv4tp">
              <Link to="/en/children" data-id="element-654" data-mp="3n2a9smxf1fu9">
                <Button variant="primary" size="lg" data-id="element-655" data-mp="3rul9pps5p1mt">
                  For Children
                </Button>
              </Link>
              <Link to="/en/adults" data-id="element-656" data-mp="p1wgiai4ub7">
                <Button variant="secondary" size="lg" data-id="element-657" data-mp="o0mkh582dv2">
                  For Adults
                </Button>
              </Link>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.22, 1, 0.36, 1]
        }} className="lg:col-span-6 relative" data-id="element-658" data-mp="9q03zak5fjyj">
            <div className="relative max-w-[520px] mx-auto" data-id="element-659" data-mp="28wyq3uhtkm07">
              <img src="https://cdn.magicpatterns.com/uploads/hGHm8r6v44K3dzDxzS719q/Hero-Image-2.png" alt="A Muslim family — father, mother, son and daughter — smiling together within an ornamental arch" className="w-full h-auto object-contain" data-id="element-660" data-mp="2456zxl2ksial" />
            </div>
          </motion.div>
        </div>
      </Container>
    </section>;
}